<template>
  <AdminLayout><ScannedItemsTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ScannedItemsTable from './ScannedItemsTable.vue';

export default {
  name: 'ScannedItems',
  components: { AdminLayout, ScannedItemsTable },
};
</script>
